import { render, staticRenderFns } from "./dialog-sender-update.vue?vue&type=template&id=5135c076&"
import script from "./dialog-sender-update.vue?vue&type=script&lang=js&"
export * from "./dialog-sender-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports